import { api } from "./api";

export const discountOffersList = async (query = "") => {
    return await api.get(`student/discount-offers-list${query ? `?${query}` : ""}`);
}

export const studentDiscountOfferApply = async (query = "") => {
    return await api.get(`/student/discount/offer/apply${query ? `?${query}` : ""}`);
}

export const studentDiscountOfferApplyPost = async (payload) => {
    return await api.post(`/student/discount/offer/apply/post`, payload);
}
